import { HttpService } from "../index";

export class AccountingService {

    constructor(
        protected httpService: HttpService
    ) {}

    prepareExport(startDate:number, endDate:number, ids:Array<any>) : Promise<any> {
        return new Promise<any> ((resolve, reject) => {
            this.httpService.post('/api/v1/accounting/export/' + startDate + '/' + endDate, ids)
                .then((response) => {
                    resolve(response.json());
                }).catch((error) => {
                    reject(error);
                });
        }); 
    }

    getRowsToExport(startDate:number, endDate:number) : Promise<any> {
        return new Promise<any> ((resolve, reject) => {
            this.httpService.get('/api/v1/accounting/export/' + startDate + '/' + endDate)
                .then((response) => {
                    resolve(response.json());
                }).catch((error) => {
                    reject(error);
                });
        });        
    }

}


// WEBPACK FOOTER //
// ./src/services/accounting/accounting-service.ts